<!-- Tire Lookup Header -->
<div class="tire-lookup-dialog-header p-2">
  <div class="tirehub-list-filter pl-2 flex-start-center pr-2">
    <!-- Header left section -->
    <div class="flex-start-center">
      <i class="fal font-16 font-gray-45 fa-filter pr-2"></i>

      <ng-container>
        <app-list-filter [options]="filterOptions" [multipleGenericFiltersKeys]="multipleGenericFiltersKeys"
          tooltipPosition="top" [multipleGenericFiltersObject]="multipleGenericFiltersObject"
          (filterChange)="filterChange($event)">
        </app-list-filter>
      </ng-container>
    </div>

    <div class="flex-center-center" *ngIf="!isQTQAddOnEnable">
      <span class="tireinventory-btns" *ngIf="isOpenFromQuickTireLookup || isOpenFromRO">
        <button class="btn btn-autoleap btn-eye-slash flex-center-center" tooltipPosition="top"
          [pTooltip]="hideCost ? 'Service Writer preview' : 'Customer Preview'" (click)="hideCost = !hideCost;">
          <i class="fa" [ngClass]="hideCost ? 'fa fa-eye' : 'fa-eye-slash'"></i>
        </button>
      </span>
      <button class="btn btn-autoleap btn-submit ml-2" (click)="isCartVisible = !isCartVisible"
        *ngIf="isOpenFromQuickTireLookup">
        <i class="far fa-shopping-cart pr-1"></i>
        cart ({{cartSummary?.count}})
      </button>
    </div>
  </div>
</div>

<!-- Tire Lookup Body -->
<div class="tire-lookup-product-body" (scroll)="onScroll($event)">
  <!-- tire inventory cart section -->
  <ng-contanier *ngIf="isCartVisible && isOpenFromQuickTireLookup && !isQTQAddOnEnable">
    <app-tire-cart [source]="'autoleap'" [hideCost]="hideCost" [cartitemList]="cartitemList" [cartSummary]="cartSummary"
      [isSubmitting]="isSubmitting" [taxAmtOnAdonService]="taxAmtOnAdonService" [shippingLoader]="shippingLoader"
      [isShippingCalculating]="false" (closeCart)="isCartVisible = $event"
      [isOpenFromQuickTireLookup]="isOpenFromQuickTireLookup"
      (appOnTireSelect)="handleTireSelect($event?.tireId, $event?.tire)"
      (appOnCountChange)="handleCountChange($event?.tireId, $event?.count, true)"
      (appOnAddCustomerAndVehicle)="handleAddCustomerAndVehicle()">
    </app-tire-cart>
  </ng-contanier>

  <div class="h-100 overflow-auto" (scroll)="onScroll($event)" [ngClass]="{'flex-center-center': !tires?.length}">
    <!-- Available tires -->
    <div class="tire-alInventory-grid-wrapper" [ngClass]="tires?.length ? 'flex-start-start flex-wrap' : ''">
      <app-tire-lookup-card source="autoleap" [ngClass]="tire?.viewDetails ? 'expand-tyre' : ''"
        *ngFor="let tire of tires" [tire]="tire" [services]="services" [orderService]="orderService"
        [selectedQty]="selectedQty" [selectedTax]="selectedTax" [selectedTire]="selectedTire[tire?._id]"
        [isTireHubModal]="false" [hideCost]="hideCost" [isOpenFromQuickTireLookup]="isOpenFromQuickTireLookup"
        [isOpenFromRO]="isOpenFromRO" [defaultServiceTotal]="defaultServiceTotal"
        (appHandleServiceCreate)="handleServiceCreate($event)"
        (appHandleServiceSelect)="handleTireSelect(tire?._id, $event)"
        (appHandleAlTireValidation)="handleAlTireValidation({tireId: tire?._id, tire:$event})">
      </app-tire-lookup-card>

      <!-- Main loader -->
      <ng-container *ngIf="(isLoading || isTireSizesLoading) else loadContainer">
        <div class="width-100 tyre-loader">
          <i class="fal fa-spinner rotate font-20"></i>
        </div>

      </ng-container>

      <ng-template #loadContainer>
        <div *ngIf="!tires?.length" class="width-100p">
          <div *ngIf="tireSize && !isOpenFromQuickTireLookup else emptyTireSizeContainer">
            <div class="flex-start-center flex-column empty-cart">
              <i class="empty-cart-icon fas fa-tire-flat"></i>

              <span class="empty-cart-text">
                Please choose any of the recommended tire sizes or select the tire size manually to see relevant results
                here.
              </span>
            </div>
          </div>

          <ng-template #emptyTireSizeContainer>
            <div class="flex-start-center flex-column empty-cart" *ngIf="!isOpenFromQuickTireLookup">
              <i class="empty-cart-icon fas fa-tire-flat"></i>

              <span class="empty-cart-text">
                Please choose any of the recommended tire sizes or select the tire size manually to see relevant results
                here.
              </span>
            </div>
            <div class="flex-start-center flex-column empty-cart" *ngIf="isOpenFromQuickTireLookup">
              <div class="flex-column flex-center-center">
                <img src="assets/img/quicktirelookup.png" />
              </div>
              <span class="empty-cart-text">
                Please select the vehicle or add tire size to view available tires.
              </span>
            </div>

          </ng-template>
        </div>
      </ng-template>
    </div>

    <!-- Progress loading loader -->
    <ng-container *ngIf="tires?.length && isTireFetching">
      <div class="tyre-loader width-100 pb-3">
        <i class="fal fa-spinner rotate font-20"></i>
      </div>
    </ng-container>
  </div>
</div>
